import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { hideModal as hideModalAction } from 'actions/modalActions';
import { useModalOffset } from 'hooks/useModalOffset';
import { DeleteModal, useKeyDown } from '@hub-mono/ui';

const DeleteConfirmationModal = ({
    title,
    message = '',
    onConfirm,
    onCancel,
    confirmText = 'Yes, delete it',
    cancelText = 'No, Cancel',
}) => {
    const dispatch = useDispatch();
    const offsetClassNames = useModalOffset();

    const hideModal = useCallback(() => {
        dispatch(hideModalAction());
        onCancel?.();
    }, [dispatch, onCancel]);

    const reject = useCallback(() => {
        hideModal();
        onCancel?.();
    }, [hideModal, onCancel]);

    const confirm = useCallback(() => {
        dispatch(hideModalAction());
        onConfirm?.();
    }, [dispatch, onConfirm]);

    const keyActions = useMemo(
        () => ({
            Enter: confirm,
        }),
        [confirm]
    );

    useKeyDown(keyActions);

    return (
        <DeleteModal
            className={offsetClassNames}
            title={title}
            content={message}
            onConfirm={confirm}
            confirmText={confirmText}
            confirmDataCy="confirm-modal-confirm"
            onCancel={reject}
            cancelText={cancelText}
            cancelDataCy="confirm-modal-cancel"
        />
    );
};

export default React.memo(DeleteConfirmationModal);
